export const hasMcu2Chip = (productId) => {
  const normalizedProductId = Number(productId);
  return Number.isFinite(normalizedProductId) && normalizedProductId !== 0;
};
